export default function FeatureSection() {
  const features = [
    {
      icon: 'ri-line-chart-line',
      title: 'Product Tracker',
      desc: 'Monitor every product across multiple marketplaces in one unified dashboard. Never lose track of an item again.',
    },
    {
      icon: 'ri-ship-line',
      title: 'Shipping Calculator',
      desc: 'Estimate international shipping costs before you buy. Compare carriers and methods to find the best rates.',
    },
    {
      icon: 'ri-money-dollar-circle-line',
      title: 'Cost Manager',
      desc: 'Track total spending including item price, shipping, taxes, and fees. See exactly where your money goes.',
    },
    {
      icon: 'ri-list-check-2',
      title: 'Order Dashboard',
      desc: 'Manage all active orders with real-time status updates. Know when each package ships and arrives.',
    },
    {
      icon: 'ri-pie-chart-line',
      title: 'Budget Planner',
      desc: 'Set shopping budgets and get alerts when you approach limits. Plan purchases across weeks or months.',
    },
    {
      icon: 'ri-scales-line',
      title: 'Comparison Tool',
      desc: 'Compare products side by side across price, shipping cost, delivery time, and seller ratings.',
    },
  ];

  return (
    <section className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex flex-col md:flex-row md:items-end justify-between mb-10 gap-3">
          <div>
            <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950">
              Superbuy Spreadsheet Feature Ecosystem
            </h2>
            <p className="text-foreground-500 text-sm md:text-base mt-2 max-w-lg">
              Six powerful modules working together to give you complete control over your international shopping experience.
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {features.map((feat) => (
            <div
              key={feat.title}
              className="group rounded-xl bg-background-100 p-5 md:p-6 hover:bg-background-200/70 transition-colors duration-200 cursor-default"
            >
              <div className="w-10 h-10 md:w-11 md:h-11 rounded-lg bg-accent-100 flex items-center justify-center mb-4">
                <i className={`${feat.icon} text-accent-600 text-lg md:text-xl`}></i>
              </div>
              <h3 className="font-semibold text-foreground-900 text-sm md:text-base mb-2">{feat.title}</h3>
              <p className="text-foreground-500 text-xs md:text-sm leading-relaxed">{feat.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}